import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import {
  getAuthData,
  getMenuArray,
  getMenuData,
  getPageDataForMenu,
  getToken,
  getOpenMenuData,
  getActiveMenuData
} from '../config/cookie';
import { useDispatch } from 'react-redux';
import { setAuthDetailsByLocalStorage } from '../redux/reducers/authSlice';
import {
  getSidebarMenu,
  setActiveModule,
  setMenusDataByLocalStorage,
  toggleExpandMenu
} from '../redux/reducers/layoutSlice';
import {
  buildMenuArrayFromPageData,
  isAdminRoleType
} from '../utils/navigationMenu';

const ProtectedRoutes = ({ routesData }) => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  const token = getToken();
  const authData = getAuthData();
  const menuData = getMenuData();
  const rawPageData = getPageDataForMenu();
  const menuArrayData = getMenuArray();
  const activeMenu = getActiveMenuData();
  const menuOpen = getOpenMenuData();
  const roleType = auth.authData?.roleType || authData?.roleType;
  const pageDataForAccess =
    rawPageData || auth.authData?.pageData || authData?.pageData;

  if (token && auth.authData?.userId === 0 && authData !== undefined) {
    dispatch(setAuthDetailsByLocalStorage(authData));
    if (rawPageData) {
      dispatch(
        getSidebarMenu({
          pageData: rawPageData,
          roleType: authData?.roleType
        })
      );
    } else if (menuData) {
      dispatch(
        setMenusDataByLocalStorage({
          menu: menuData,
          roleType: authData?.roleType
        })
      );
    }
    dispatch(setActiveModule(activeMenu));
    dispatch(toggleExpandMenu(menuOpen));
  }

  const isAuthenticated = Boolean(token && authData?.userId);

  const currentPath = window.location.pathname;

  const effectiveMenuAccess =
    menuArrayData && menuArrayData.length > 0
      ? menuArrayData
      : buildMenuArrayFromPageData(pageDataForAccess, roleType);

  let accessibleRoutess = {};
  if (effectiveMenuAccess?.length) {
    accessibleRoutess = generateAccessibleRoutes(
      routesData,
      effectiveMenuAccess,
      roleType
    );
  }

  // console.log(`3 exit`)
  if (isAuthenticated) {
    if (accessibleRoutess && accessibleRoutess[currentPath]) {
      return <Outlet />;
    } else {
      return <Navigate to="/forbidden" />;
    }
  } else {
    return <Navigate to="/login" />;
  }
};

const generateAccessibleRoutes = (routesData, userAccessData, roleType) => {
  const accessibleRoutes = {};
  const normalizedAccess = (userAccessData || []).map(name =>
    String(name).toLowerCase()
  );

  routesData.forEach(route => {
    const menuName = String(route.menu_name || '').toLowerCase();
    accessibleRoutes[route.path] =
      normalizedAccess.includes(menuName) ||
      menuName === 'my account' ||
      (menuName === 'dashboard' && isAdminRoleType(roleType));
  });

  return accessibleRoutes;
};

export default ProtectedRoutes;
